module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row justify-content-center"
  }, [_c('div', {
    staticClass: "col-lg-8 col-md-12"
  }, [_c('h1', [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('h2', [_vm._v(_vm._s(_vm.subtitle))]), _vm._v(" "), _c('p', [_vm._v("Start your boilerplate search using either the text input or boilerplate categories")]), _vm._v(" "), _c('boilerplatesearch')], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4d8a09cf","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/boilerplate-index.vue
// module id = 187
// module chunks = 1